import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { API_RESULT, ERROR_MESSAGES } from "../../../../utils/constants";
import { useBulkUpdateVendorAuditSchedule, useUpdateVendorAuditSchedule } from "../../../../backend/masters";
import { ACTIVITY_STATUS } from "../../../common/Constants";
import PageLoader from "../../../shared/PageLoader";
import { AxiosError } from "axios";

function VendorBulkUnBlockModal({ selected = {}, onClose, onSubmit }: any) {
  const [newDueDate, setNewDueDate] = useState<any>(new Date());
  const [payloads, setPayloads] = useState<any>([]);
  const [updatingCount, setUpdatingCount] = useState(0);
  const [upadingAudit, setUpdatingAudit] = useState(false);
  const [totalAuditsUpdating, setTotalAuditsUpdating] = useState(0);
  const { updateAuditSchedule, updating } =
    useUpdateVendorAuditSchedule((response: any) => {
      if (response instanceof AxiosError){
          const data = (response.response || {}).data;
          const error = (data || {}).error || ERROR_MESSAGES.DEFAULT;
          toast.error(error);
      } else {
          setUpdatingCount(updatingCount + 1);
      }
    });

  function submit() {
    const payloads: any[] = selected.map((activity: any) => {
        const { id } = activity;
        return {
          todo_vendor: {
            id,
            dueDate: new Date(newDueDate).toISOString(),
            status: [ACTIVITY_STATUS.OVERDUE].includes(activity.status) ? ACTIVITY_STATUS.PENDING : activity.status
          }
        }
    });
    const count = payloads.length;
    setTotalAuditsUpdating(count);
    const payload = payloads.shift();
    setUpdatingAudit(true);
    setPayloads(payloads);
    updateAuditSchedule(payload);
  }

  useEffect(() => {
      if (updatingCount && updatingCount != totalAuditsUpdating) {
          const tempPayloads = [...payloads];
          const payload = tempPayloads.shift();
          setPayloads(tempPayloads);
          updateAuditSchedule(payload)
      } else if(updatingCount && updatingCount == totalAuditsUpdating) {
          setUpdatingAudit(false);
          setTotalAuditsUpdating(0);
          setUpdatingCount(0);
          setPayloads([]);
          toast.success('Activities unblocked successfully.');
          onClose();
          onSubmit();
      }
  }, [updatingCount]);

  return (
    <>
      {
        <Modal show={true} backdrop="static" animation={false}>
          <Modal.Header closeButton={true} onHide={onClose}>
            <Modal.Title className="bg">Un-Block Activities</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ minHeight: '520px' }}>
            <div className="d-flex justify-content-center">
              <div className="col-11">
                <p className="text-center mb-2">
                  There are <strong>{selected.length} activites</strong>{" "}
                  selected to Un-Block
                </p>
                <p className="text-center mb-4">
                  Provide new due date to unblock the selected activities. This
                  will provide vendor to access and resubmit the blocked
                  activities.
                </p>
                <div className="row mb-4">
                  <div className="col-4 filter-label">Due Date</div>
                  <div className="col-6">
                    <DatePicker
                      className="form-control"
                      selected={newDueDate}
                      dateFormat="dd-MM-yyyy"
                      onChange={setNewDueDate}
                      placeholderText="dd-mm-yyyy"
                      minDate={new Date()}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
            <Button
              variant="outline-secondary"
              onClick={onClose}
              className="btn btn-outline-secondary"
            >
              Back
            </Button>
            <Button variant="primary" onClick={submit}>
              Un-Block
            </Button>
          </Modal.Footer>
        </Modal>
      }
      {upadingAudit && <PageLoader message={`Updating ${updatingCount + 1} of ${selected.length}`} />}
    </>
  );
}

export default VendorBulkUnBlockModal;
